import React from 'react';

import { BrandColor } from '@styleseat/brand';
import analytics from '../../../../modules/analytics';
import type { State as UserModelState } from '../../../../store/CurrentUser.types';
import { ModalBox, PortalOverlay } from '../../../ui';
import {
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
} from '../../../ui/PortalOverlay';
import { NotifyMeRequestForChatFormContainer } from './NotifyMeRequestForChatFormContainer';

export type NotifyMeRequestForChatModalContainerProps = {
  headerText: React.ReactNode;
  onClose: () => void;
  user: UserModelState;
  trackingParams: Record<string, any>;
  onSuccess: () => void;
};

export const NotifyMeRequestForChatModalContainer: React.FCWithChildren<
NotifyMeRequestForChatModalContainerProps
> = ({
  headerText,
  onClose = () => {},
  user,
  trackingParams,
  onSuccess,
}) => {
  const handleCloseRequest = () => {
    analytics.track('client_notify_me_for_chat_modal_closed', {
      ...trackingParams,
    });
    onClose();
  };

  return (
    <PortalOverlay name="client_notify_me_for_chat_modal">
      <PortalOverlayModal position="fullScreen" testID="client_notify_me_for_chat_modal">
        <PortalOverlayHeader
          color={BrandColor.WhiteWash}
          hideBottomBorder
          renderRightAction={() => (
            <PortalOverlayHeaderCloseBtn onCloseRequest={handleCloseRequest} testID="client_notify_me_for_chat_modal_close_button" />
          )}
        />
        <ModalBox padding={24}>
          <NotifyMeRequestForChatFormContainer
            trackingParams={trackingParams}
            onSuccess={onSuccess}
            user={user}
            headerText={headerText}
          />
        </ModalBox>
      </PortalOverlayModal>
    </PortalOverlay>
  );
};
